import { Flex } from 'roo-ui/components';
import PointsLogo from '../PointsLogo';
import PointsItem from '../PointsItem';

const QbrPoints = ({ qbrPoints }) => {
  return (
    <Flex flexDirection={['column', 'row']} data-testid="qbr-points-section">
      <PointsLogo brand="qbr" />
      <Flex flex="2 0 auto" flexDirection="column" justifyContent="center" width={['100%', '66.666%']}>
        <PointsItem description="Qantas Points for Business earned" points={qbrPoints} />
      </Flex>
    </Flex>
  );
};

export default QbrPoints;
